export const GIG_FLOW_PAGE_SIZE = 48;
export const ROLE_SEARCH_FLOW_PAGE_SIZE = 18;
